import { BuilderElement } from '@builder.io/react'

export const defaultTextChild: BuilderElement = {
  '@type': '@builder.io/sdk:Element',
  component: {
    name: 'Text',
    options: { text: 'You can drag and drop blocks here!' },
  },
}
